// Expanded collection of beautiful, diverse nature images from Unsplash
// Each image is unique and carefully selected for visual appeal
export const natureImages = [
  // Mountains & Landscapes
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Mountain lake
  'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=500&h=400&fit=crop&auto=format&q=80', // Forest path
  'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=500&h=400&fit=crop&auto=format&q=80', // Mountain peaks
  'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=500&h=400&fit=crop&auto=format&q=80', // Lake reflection
  'https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=500&h=400&fit=crop&auto=format&q=80', // Forest canopy
  
  // Ocean & Water
  'https://images.unsplash.com/photo-1475924156734-496f6cac6ec1?w=500&h=400&fit=crop&auto=format&q=80', // Ocean waves
  'https://images.unsplash.com/photo-1464822759844-d150baec3e5b?w=500&h=400&fit=crop&auto=format&q=80', // Mountain lake
  'https://images.unsplash.com/photo-1501436513145-30f24e19fcc4?w=500&h=400&fit=crop&auto=format&q=80', // Tropical beach
  'https://images.unsplash.com/photo-1482938289607-e9573fc25ebb?w=500&h=400&fit=crop&auto=format&q=80', // Waterfall
  'https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=500&h=400&fit=crop&auto=format&q=80', // Lake at dawn
  
  // Deserts & Unique Landscapes  
  'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=500&h=400&fit=crop&auto=format&q=80', // Desert dunes
  'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=500&h=400&fit=crop&auto=format&q=80', // Canyon
  'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=500&h=400&fit=crop&auto=format&q=80', // Valley view
  'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=500&h=400&fit=crop&auto=format&q=80', // Rock formations
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Alpine lake
  
  // Fields & Meadows
  'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=500&h=400&fit=crop&auto=format&q=80', // Rolling hills
  'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=500&h=400&fit=crop&auto=format&q=80', // Sunset field
  'https://images.unsplash.com/photo-1441260038675-7329ab4cc264?w=500&h=400&fit=crop&auto=format&q=80', // Flower field
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Meadow path
  'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=500&h=400&fit=crop&auto=format&q=80', // Pastoral scene
  
  // Forests & Trees
  'https://images.unsplash.com/photo-1448375240586-882707db888b?w=500&h=400&fit=crop&auto=format&q=80', // Misty forest
  'https://images.unsplash.com/photo-1511593358241-7eea1f3c84e5?w=500&h=400&fit=crop&auto=format&q=80', // Autumn forest
  'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?w=500&h=400&fit=crop&auto=format&q=80', // Pine forest
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Forest lake
  'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=500&h=400&fit=crop&auto=format&q=80', // Redwood forest
  
  // Sky & Clouds
  'https://images.unsplash.com/photo-1492571350019-22de08371fd3?w=500&h=400&fit=crop&auto=format&q=80', // Dramatic sky
  'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?w=500&h=400&fit=crop&auto=format&q=80', // Sunset clouds
  'https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=500&h=400&fit=crop&auto=format&q=80', // Storm clouds
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Mountain sky
  'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=500&h=400&fit=crop&auto=format&q=80', // Golden hour
  
  // Rivers & Streams
  'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=500&h=400&fit=crop&auto=format&q=80', // River canyon
  'https://images.unsplash.com/photo-1440342359743-84fcb8c21f21?w=500&h=400&fit=crop&auto=format&q=80', // Mountain stream
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Crystal river
  'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=500&h=400&fit=crop&auto=format&q=80', // Forest creek
  'https://images.unsplash.com/photo-1482938289607-e9573fc25ebb?w=500&h=400&fit=crop&auto=format&q=80', // Cascade falls
  
  // Unique Landscapes
  'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=500&h=400&fit=crop&auto=format&q=80', // Volcanic landscape
  'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=500&h=400&fit=crop&auto=format&q=80', // Cliff face
  'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=500&h=400&fit=crop&auto=format&q=80', // Sand patterns
  'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=500&h=400&fit=crop&auto=format&q=80', // Slot canyon
  'https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=500&h=400&fit=crop&auto=format&q=80', // Glacier lake
  
  // Additional Unique Images
  'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=500&h=400&fit=crop&auto=format&q=80', // Prairie sunset
  'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=500&h=400&fit=crop&auto=format&q=80', // Wheat field
  'https://images.unsplash.com/photo-1441260038675-7329ab4cc264?w=500&h=400&fit=crop&auto=format&q=80', // Wildflowers
  'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=500&h=400&fit=crop&auto=format&q=80', // Rolling meadows
  'https://images.unsplash.com/photo-1448375240586-882707db888b?w=500&h=400&fit=crop&auto=format&q=80', // Foggy valley
  
  // More Diverse Landscapes
  'https://images.unsplash.com/photo-1511593358241-7eea1f3c84e5?w=500&h=400&fit=crop&auto=format&q=80', // Autumn colors
  'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?w=500&h=400&fit=crop&auto=format&q=80', // Dense forest
  'https://images.unsplash.com/photo-1492571350019-22de08371fd3?w=500&h=400&fit=crop&auto=format&q=80', // Epic sky
  'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?w=500&h=400&fit=crop&auto=format&q=80', // Horizon view
  'https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=500&h=400&fit=crop&auto=format&q=80', // Storm approach
  
  // Final Unique Set
  'https://images.unsplash.com/photo-1440342359743-84fcb8c21f21?w=500&h=400&fit=crop&auto=format&q=80', // Rocky stream
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80', // Mirror lake
  'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=500&h=400&fit=crop&auto=format&q=80', // Perfect reflection
  'https://images.unsplash.com/photo-1482938289607-e9573fc25ebb?w=500&h=400&fit=crop&auto=format&q=80', // Tropical cascade
  'https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=500&h=400&fit=crop&auto=format&q=80'  // Dawn serenity
]

// Get a unique nature image for each class number
export const getPlaceholderImage = (classNumber) => {
  // Ensure we have a valid class number
  const safeClassNumber = Math.max(1, Math.min(classNumber || 1, 285))
  
  // Use modulo to cycle through images, but add some variation
  const imageIndex = (safeClassNumber - 1) % natureImages.length
  
  return natureImages[imageIndex]
}

// Get a darker version of the image for subtle backgrounds
export const getDarkerPlaceholderImage = (classNumber) => {
  const baseUrl = getPlaceholderImage(classNumber)
  // Add darker filter parameters to the Unsplash URL
  return baseUrl.replace('&q=80', '&q=80&brightness=-20&contrast=10')
}

// Fallback image in case of loading errors
export const getFallbackImage = () => {
  return 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&auto=format&q=80&brightness=-10'
}